import { render, staticRenderFns } from "./PraticaStepperTracking.vue?vue&type=template&id=2f63e46b&scoped=true&"
import script from "./PraticaStepperTracking.vue?vue&type=script&lang=js&"
export * from "./PraticaStepperTracking.vue?vue&type=script&lang=js&"
import style0 from "./PraticaStepperTracking.vue?vue&type=style&index=0&id=2f63e46b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63e46b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f63e46b')) {
      api.createRecord('2f63e46b', component.options)
    } else {
      api.reload('2f63e46b', component.options)
    }
    module.hot.accept("./PraticaStepperTracking.vue?vue&type=template&id=2f63e46b&scoped=true&", function () {
      api.rerender('2f63e46b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaStepperTracking.vue"
export default component.exports